import * as React from 'react';

import MetadataBadge16 from './MetadataBadge16';

export const metadataBadge16 = () => <MetadataBadge16 />;

export default {
    title: 'Icon/Line/MetadataBadge16',
    component: MetadataBadge16,
    parameters: {
        notes: "`import MetadataBadge16 from 'box-ui-elements/es/icon/line/MetadataBadge16';`",
    },
};
